"use client";

import _defineProperty from "/var/www/html/meameal/prod/front_meameal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { genFocusOutline, resetComponent } from '../../style';
import { genStyleHooks, mergeToken } from '../../theme/internal'; // ============================== Styles ==============================
// styles from RadioGroup only

var getGroupRadioStyle = function getGroupRadioStyle(token) {
  var _Object$assign;

  var componentCls = token.componentCls,
      antCls = token.antCls;
  var groupPrefixCls = "".concat(componentCls, "-group");
  return _defineProperty({}, groupPrefixCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    display: 'inline-block',
    fontSize: 0
  }, _defineProperty(_Object$assign, "&".concat(groupPrefixCls, "-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_Object$assign, "".concat(antCls, "-badge ").concat(antCls, "-badge-count"), {
    zIndex: 1
  }), _defineProperty(_Object$assign, "> ".concat(antCls, "-badge:not(:first-child) > ").concat(antCls, "-button-wrapper"), {
    borderInlineStart: 'none'
  }), _Object$assign)));
}; // Styles from radio-wrapper


var getRadioBasicStyle = function getRadioBasicStyle(token) {
  var _$concat3, _Object$assign2;

  var componentCls = token.componentCls,
      wrapperMarginInlineEnd = token.wrapperMarginInlineEnd,
      colorPrimary = token.colorPrimary,
      radioSize = token.radioSize,
      motionDurationSlow = token.motionDurationSlow,
      motionDurationMid = token.motionDurationMid,
      motionEaseInOutCirc = token.motionEaseInOutCirc,
      colorBgContainer = token.colorBgContainer,
      colorBorder = token.colorBorder,
      lineWidth = token.lineWidth,
      colorBgContainerDisabled = token.colorBgContainerDisabled,
      colorTextDisabled = token.colorTextDisabled,
      paddingXS = token.paddingXS,
      dotColorDisabled = token.dotColorDisabled,
      lineType = token.lineType,
      radioColor = token.radioColor,
      radioBgColor = token.radioBgColor,
      calc = token.calc;
  var radioInnerPrefixCls = "".concat(componentCls, "-inner");
  var dotPadding = 4;
  var radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
  var radioSizeCalc = calc(1).mul(radioSize).equal();
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign2 = {
    display: 'inline-flex',
    alignItems: 'baseline',
    marginInlineStart: 0,
    marginInlineEnd: wrapperMarginInlineEnd,
    cursor: 'pointer'
  }, _defineProperty(_Object$assign2, "&".concat(componentCls, "-wrapper-rtl"), {
    direction: 'rtl'
  }), _defineProperty(_Object$assign2, '&-disabled', {
    cursor: 'not-allowed',
    color: token.colorTextDisabled
  }), _defineProperty(_Object$assign2, '&::after', {
    display: 'inline-block',
    width: 0,
    overflow: 'hidden',
    content: '"\\a0"'
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-checked::after"), {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    width: '100%',
    height: '100%',
    border: "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(colorPrimary),
    borderRadius: '50%',
    visibility: 'hidden',
    content: '""'
  }), _defineProperty(_Object$assign2, componentCls, Object.assign(Object.assign({}, resetComponent(token)), {
    position: 'relative',
    display: 'inline-block',
    outline: 'none',
    cursor: 'pointer',
    alignSelf: 'center',
    borderRadius: '50%'
  })), _defineProperty(_Object$assign2, "".concat(componentCls, "-wrapper:hover &,\n        &:hover ").concat(radioInnerPrefixCls), {
    borderColor: colorPrimary
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-input:focus-visible + ").concat(radioInnerPrefixCls), Object.assign({}, genFocusOutline(token))), _defineProperty(_Object$assign2, "".concat(componentCls, ":hover::after, ").concat(componentCls, "-wrapper:hover &::after"), {
    visibility: 'visible'
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-inner"), {
    '&::after': {
      boxSizing: 'border-box',
      position: 'absolute',
      insetBlockStart: '50%',
      insetInlineStart: '50%',
      display: 'block',
      width: radioSizeCalc,
      height: radioSizeCalc,
      marginBlockStart: calc(1).mul(radioSize).div(-2).equal(),
      marginInlineStart: calc(1).mul(radioSize).div(-2).equal(),
      backgroundColor: radioColor,
      borderBlockStart: 0,
      borderInlineStart: 0,
      borderRadius: radioSizeCalc,
      transform: 'scale(0)',
      opacity: 0,
      transition: "all ".concat(motionDurationSlow, " ").concat(motionEaseInOutCirc),
      content: '""'
    },
    boxSizing: 'border-box',
    position: 'relative',
    insetBlockStart: 0,
    insetInlineStart: 0,
    display: 'block',
    width: radioSizeCalc,
    height: radioSizeCalc,
    backgroundColor: colorBgContainer,
    borderColor: colorBorder,
    borderStyle: 'solid',
    borderWidth: lineWidth,
    borderRadius: '50%',
    transition: "all ".concat(motionDurationMid)
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-input"), {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    cursor: 'pointer',
    opacity: 0
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-checked"), _defineProperty({}, radioInnerPrefixCls, {
    borderColor: colorPrimary,
    backgroundColor: radioBgColor,
    '&::after': {
      transform: "scale(".concat(token.calc(token.dotSize).div(radioSize).equal(), ")"),
      opacity: 1,
      transition: "all ".concat(motionDurationSlow, " ").concat(motionEaseInOutCirc)
    }
  })), _defineProperty(_Object$assign2, "".concat(componentCls, "-disabled"), (_$concat3 = {
    cursor: 'not-allowed'
  }, _defineProperty(_$concat3, radioInnerPrefixCls, {
    backgroundColor: colorBgContainerDisabled,
    borderColor: colorBorder,
    cursor: 'not-allowed',
    '&::after': {
      backgroundColor: dotColorDisabled
    }
  }), _defineProperty(_$concat3, "".concat(componentCls, "-input"), {
    cursor: 'not-allowed'
  }), _defineProperty(_$concat3, "".concat(componentCls, "-disabled + span"), {
    color: colorTextDisabled,
    cursor: 'not-allowed'
  }), _defineProperty(_$concat3, "&".concat(componentCls, "-checked"), _defineProperty({}, radioInnerPrefixCls, {
    '&::after': {
      transform: "scale(".concat(calc(radioDotDisabledSize).div(radioSize).equal({
        unit: false
      }), ")")
    }
  })), _$concat3)), _defineProperty(_Object$assign2, "span".concat(componentCls, " + *"), {
    paddingInlineStart: paddingXS,
    paddingInlineEnd: paddingXS
  }), _Object$assign2)));
}; // Styles from radio-button


var getRadioButtonStyle = function getRadioButtonStyle(token) {
  var _$concat4;

  var buttonColor = token.buttonColor,
      controlHeight = token.controlHeight,
      componentCls = token.componentCls,
      lineWidth = token.lineWidth,
      lineType = token.lineType,
      colorBorder = token.colorBorder,
      motionDurationSlow = token.motionDurationSlow,
      motionDurationMid = token.motionDurationMid,
      buttonPaddingInline = token.buttonPaddingInline,
      fontSize = token.fontSize,
      buttonBg = token.buttonBg,
      fontSizeLG = token.fontSizeLG,
      controlHeightLG = token.controlHeightLG,
      controlHeightSM = token.controlHeightSM,
      paddingXS = token.paddingXS,
      borderRadius = token.borderRadius,
      borderRadiusSM = token.borderRadiusSM,
      borderRadiusLG = token.borderRadiusLG,
      buttonCheckedBg = token.buttonCheckedBg,
      buttonSolidCheckedColor = token.buttonSolidCheckedColor,
      colorTextDisabled = token.colorTextDisabled,
      colorBgContainerDisabled = token.colorBgContainerDisabled,
      buttonCheckedBgDisabled = token.buttonCheckedBgDisabled,
      buttonCheckedColorDisabled = token.buttonCheckedColorDisabled,
      colorPrimary = token.colorPrimary,
      colorPrimaryHover = token.colorPrimaryHover,
      colorPrimaryActive = token.colorPrimaryActive,
      buttonSolidCheckedBg = token.buttonSolidCheckedBg,
      buttonSolidCheckedHoverBg = token.buttonSolidCheckedHoverBg,
      buttonSolidCheckedActiveBg = token.buttonSolidCheckedActiveBg,
      calc = token.calc;
  return _defineProperty({}, "".concat(componentCls, "-button-wrapper"), (_$concat4 = {
    position: 'relative',
    display: 'inline-block',
    height: controlHeight,
    margin: 0,
    paddingInline: buttonPaddingInline,
    paddingBlock: 0,
    color: buttonColor,
    fontSize: fontSize,
    lineHeight: unit(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
    background: buttonBg,
    border: "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(colorBorder),
    // strange align fix for chrome but works
    // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
    borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
    borderInlineStartWidth: 0,
    borderInlineEndWidth: lineWidth,
    cursor: 'pointer',
    transition: ["color ".concat(motionDurationMid), "background ".concat(motionDurationMid), "box-shadow ".concat(motionDurationMid)].join(','),
    a: {
      color: buttonColor
    }
  }, _defineProperty(_$concat4, "> ".concat(componentCls, "-button"), {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    zIndex: -1,
    width: '100%',
    height: '100%'
  }), _defineProperty(_$concat4, '&:not(:first-child)', {
    '&::before': {
      position: 'absolute',
      insetBlockStart: calc(lineWidth).mul(-1).equal(),
      insetInlineStart: calc(lineWidth).mul(-1).equal(),
      display: 'block',
      boxSizing: 'content-box',
      width: 1,
      height: '100%',
      paddingBlock: lineWidth,
      paddingInline: 0,
      backgroundColor: colorBorder,
      transition: "background-color ".concat(motionDurationSlow),
      content: '""'
    }
  }), _defineProperty(_$concat4, '&:first-child', {
    borderInlineStart: "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(colorBorder),
    borderStartStartRadius: borderRadius,
    borderEndStartRadius: borderRadius
  }), _defineProperty(_$concat4, '&:last-child', {
    borderStartEndRadius: borderRadius,
    borderEndEndRadius: borderRadius
  }), _defineProperty(_$concat4, '&:first-child:last-child', {
    borderRadius: borderRadius
  }), _defineProperty(_$concat4, "".concat(componentCls, "-group-large &"), {
    height: controlHeightLG,
    fontSize: fontSizeLG,
    lineHeight: unit(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
    '&:first-child': {
      borderStartStartRadius: borderRadiusLG,
      borderEndStartRadius: borderRadiusLG
    },
    '&:last-child': {
      borderStartEndRadius: borderRadiusLG,
      borderEndEndRadius: borderRadiusLG
    }
  }), _defineProperty(_$concat4, "".concat(componentCls, "-group-small &"), {
    height: controlHeightSM,
    paddingInline: calc(paddingXS).sub(lineWidth).equal(),
    paddingBlock: 0,
    lineHeight: unit(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
    '&:first-child': {
      borderStartStartRadius: borderRadiusSM,
      borderEndStartRadius: borderRadiusSM
    },
    '&:last-child': {
      borderStartEndRadius: borderRadiusSM,
      borderEndEndRadius: borderRadiusSM
    }
  }), _defineProperty(_$concat4, '&:hover', {
    position: 'relative',
    color: colorPrimary
  }), _defineProperty(_$concat4, '&:has(:focus-visible)', Object.assign({}, genFocusOutline(token))), _defineProperty(_$concat4, "".concat(componentCls, "-inner, input[type='checkbox'], input[type='radio']"), {
    width: 0,
    height: 0,
    opacity: 0,
    pointerEvents: 'none'
  }), _defineProperty(_$concat4, "&-checked:not(".concat(componentCls, "-button-wrapper-disabled)"), {
    zIndex: 1,
    color: colorPrimary,
    background: buttonCheckedBg,
    borderColor: colorPrimary,
    '&::before': {
      backgroundColor: colorPrimary
    },
    '&:first-child': {
      borderColor: colorPrimary
    },
    '&:hover': {
      color: colorPrimaryHover,
      borderColor: colorPrimaryHover,
      '&::before': {
        backgroundColor: colorPrimaryHover
      }
    },
    '&:active': {
      color: colorPrimaryActive,
      borderColor: colorPrimaryActive,
      '&::before': {
        backgroundColor: colorPrimaryActive
      }
    }
  }), _defineProperty(_$concat4, "".concat(componentCls, "-group-solid &-checked:not(").concat(componentCls, "-button-wrapper-disabled)"), {
    color: buttonSolidCheckedColor,
    background: buttonSolidCheckedBg,
    borderColor: buttonSolidCheckedBg,
    '&:hover': {
      color: buttonSolidCheckedColor,
      background: buttonSolidCheckedHoverBg,
      borderColor: buttonSolidCheckedHoverBg
    },
    '&:active': {
      color: buttonSolidCheckedColor,
      background: buttonSolidCheckedActiveBg,
      borderColor: buttonSolidCheckedActiveBg
    }
  }), _defineProperty(_$concat4, '&-disabled', {
    color: colorTextDisabled,
    backgroundColor: colorBgContainerDisabled,
    borderColor: colorBorder,
    cursor: 'not-allowed',
    '&:first-child, &:hover': {
      color: colorTextDisabled,
      backgroundColor: colorBgContainerDisabled,
      borderColor: colorBorder
    }
  }), _defineProperty(_$concat4, "&-disabled".concat(componentCls, "-button-wrapper-checked"), {
    color: buttonCheckedColorDisabled,
    backgroundColor: buttonCheckedBgDisabled,
    borderColor: colorBorder,
    boxShadow: 'none'
  }), _$concat4));
}; // ============================== Export ==============================


export var prepareComponentToken = function prepareComponentToken(token) {
  var wireframe = token.wireframe,
      padding = token.padding,
      marginXS = token.marginXS,
      lineWidth = token.lineWidth,
      fontSizeLG = token.fontSizeLG,
      colorText = token.colorText,
      colorBgContainer = token.colorBgContainer,
      colorTextDisabled = token.colorTextDisabled,
      controlItemBgActiveDisabled = token.controlItemBgActiveDisabled,
      colorTextLightSolid = token.colorTextLightSolid,
      colorPrimary = token.colorPrimary,
      colorPrimaryHover = token.colorPrimaryHover,
      colorPrimaryActive = token.colorPrimaryActive,
      colorWhite = token.colorWhite;
  var dotPadding = 4; // Fixed value

  var radioSize = fontSizeLG;
  var radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
  return {
    // Radio
    radioSize: radioSize,
    dotSize: radioDotSize,
    dotColorDisabled: colorTextDisabled,
    // Radio buttons
    buttonSolidCheckedColor: colorTextLightSolid,
    buttonSolidCheckedBg: colorPrimary,
    buttonSolidCheckedHoverBg: colorPrimaryHover,
    buttonSolidCheckedActiveBg: colorPrimaryActive,
    buttonBg: colorBgContainer,
    buttonCheckedBg: colorBgContainer,
    buttonColor: colorText,
    buttonCheckedBgDisabled: controlItemBgActiveDisabled,
    buttonCheckedColorDisabled: colorTextDisabled,
    buttonPaddingInline: padding - lineWidth,
    wrapperMarginInlineEnd: marginXS,
    // internal
    radioColor: wireframe ? colorPrimary : colorWhite,
    radioBgColor: wireframe ? colorBgContainer : colorPrimary
  };
};
export default genStyleHooks('Radio', function (token) {
  var controlOutline = token.controlOutline,
      controlOutlineWidth = token.controlOutlineWidth;
  var radioFocusShadow = "0 0 0 ".concat(unit(controlOutlineWidth), " ").concat(controlOutline);
  var radioButtonFocusShadow = radioFocusShadow;
  var radioToken = mergeToken(token, {
    radioFocusShadow: radioFocusShadow,
    radioButtonFocusShadow: radioButtonFocusShadow
  });
  return [getGroupRadioStyle(radioToken), getRadioBasicStyle(radioToken), getRadioButtonStyle(radioToken)];
}, prepareComponentToken, {
  unitless: {
    radioSize: true,
    dotSize: true
  }
});